module.exports = __webpack_public_path__ + "img/titus.ed92cf3f.png";